import styled from 'styled-components';
import { Select, CountrySelect } from 'components/Inputs';
import _LoadingOverlay from 'components/LoadingOverlay';
import Feedback from 'products/nomad_insurance/components/Feedback';
import { H6 } from 'components/Typography';
import { sizes } from 'style';

export const CurrencySelect = styled(Select)`
  width: 160px;
  margin-top: 16px;
`;

export const BankInfoHeading = styled(H6)`
  margin-bottom: 16px;

  @media ${sizes.tabletPortrait} {
    margin-top: 36px;
  }
`;

export const StyledCountrySelect = styled(CountrySelect)`
  margin-top: 16px;
`;

export const BankInfo = styled.div`
  @media ${sizes.tabletPortrait} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 46px;
  }
`;

export const LoadingOverlay = styled(_LoadingOverlay)`
  position: fixed;
`;

export const StyledFeedback = styled(Feedback)`
  margin-bottom: 24px;
`;
